import React, { ReactNode } from "react";
import { usePageStyles } from "../styles/usePageStyles";

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'quick';

interface ActionButtonProps {
  children: ReactNode;
  variant?: ButtonVariant;
  onClick?: () => void;
  icon?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
}

/**
 * Action button component with theme-aware styling
 */
export const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  variant = 'secondary',
  onClick,
  icon,
  className,
  style,
  type = 'button'
}) => {
  const styles = usePageStyles();

  const getButtonStyle = () => {
    switch (variant) {
      case 'primary':
        return styles.primaryButton;
      case 'danger':
        return { ...styles.headerButton, ...styles.dangerButton };
      case 'quick':
        return styles.quickActionButton;
      default:
        return styles.headerButton;
    }
  };

  return (
    <button
      type={type}
      onClick={onClick}
      style={{ ...getButtonStyle(), ...style }}
      className={className}
    >
      {icon && <span>{icon}</span>}
      {children}
    </button>
  );
};
